import { apiClient } from './client';
import type { ApiResponse, DashboardStatsResponse, Campaign } from '@/types/api.types';

export const dashboardApi = {
  stats: (period: '7d' | '30d' | '90d' = '30d') =>
    apiClient.get<ApiResponse<DashboardStatsResponse>>('/dashboard/stats', { params: { period } }),

  recent: () =>
    apiClient.get<ApiResponse<Campaign[]>>('/dashboard/recent'),
};
